import React from 'react';
import styled from 'styled-components/native';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
} from 'app/src/elements';
import { View, Text, Dimensions } from 'react-native';
const dimensions = Dimensions.get('window');
const smallScreen = dimensions.width < 800;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileInvoiceDollar,
  faFileContract,
  faBalanceScale,
  faMoneyBill,
  faMoneyCheckAlt,
  faWallet,
  faFileInvoice,
  faFileArchive,
  faFileExport
} from '@fortawesome/free-solid-svg-icons';
import { elGray, elLightGray, elRed } from '../../../styles/colors';
import { Link } from 'react-router-dom';

const UpperContainer = styled(View)`
  display: flex;
  flex-direction: ${ smallScreen ? 'column' : 'row'};
  gap: 10px;
`;

const LowerContainer = styled(View)`
  margin-top: 10px;
  display: flex;
  flex-direction: ${ smallScreen ? 'column' : 'row'};
  gap: 10px;
`;

const LinksContainer = styled(View)`
  display: flex;
  min-height: 300px;
  min-width: ${smallScreen ? '100%' : '33%'};
  width: fit-content;
  flex-direction: column
  background-color: ${elLightGray};
  border: 3px solid ${elRed};
  padding: 20px;
  border-radius: 10px;
  gap: 10px;
`;

const GraphsContainer = styled(View)`
  display: flex;
  min-height: 300px;
  min-width: ${smallScreen ? '100%' : '50%'};
  width: fit-content;
  flex-direction: column
  background-color: ${elLightGray};
  border: 3px solid ${elRed};
  padding: 20px;
  border-radius: 10px;
  gap: 10px;
`;

const LinkWording = styled(Text)`
  font-weight: bold;
  font-size: 18px;
`;

const ContainerLabel = styled(Text)`
  font-weight: bold;
  font-size: 22px;
`;

const AccountingDashboard = () => {
  return (
    <MainContainer>
      <ContentContainer>
        <PageTitle>Accounting Dashboard</PageTitle>
        {/* <UpperContainer>
          <GraphsContainer>

          </GraphsContainer>
          <GraphsContainer>

          </GraphsContainer>
        </UpperContainer> */}
        <LowerContainer>
          <LinksContainer>
            <ContainerLabel>Settings</ContainerLabel>
            <LinkContainer>
              <Link
                to={"/accounting/accounts"}
                style={{textDecoration: 'none', marginTop: '10px'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faFileInvoiceDollar}
                    size='2x'
                    style={{color: elRed}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Accounts
                </LinkWording>
              </Link>
            </LinkContainer>
            <LinkContainer>
              <Link
                to={"/accounting/account-groups"}
                style={{textDecoration: 'none'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faFileInvoiceDollar}
                    size='2x'
                    style={{color: elGray}}
                  />
                  <FontAwesomeIcon
                    icon={faFileInvoiceDollar}
                    size='2x'
                    style={{color: elRed, paddingLeft: '7.5px', paddingTop: '7.5px'}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Account Groups
                </LinkWording>
              </Link>
            </LinkContainer>
            <LinkContainer>
              <Link
                to={"/accounting/payment-terms"}
                style={{textDecoration: 'none'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faFileContract}
                    size='2x'
                    style={{color: elRed}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Payment Terms
                </LinkWording>
              </Link>
            </LinkContainer>
            <LinkContainer>
              <Link
                to={"/accounting/reconciliation"}
                style={{textDecoration: 'none'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faBalanceScale}
                    size='2x'
                    style={{color: elRed}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Reconciles
                </LinkWording>
              </Link>
            </LinkContainer>
          </LinksContainer>
          <LinksContainer>
            <ContainerLabel>Transactions</ContainerLabel>
            <LinkContainer>
              <Link
                to={"/accounting/transactions"}
                style={{textDecoration: 'none', marginTop: '10px'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faMoneyBill}
                    size='2x'
                    style={{color: elRed}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Txns
                </LinkWording>
              </Link>
            </LinkContainer>
            <LinkContainer>
              <Link
                to={"/accounting/expenses"}
                style={{textDecoration: 'none'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faMoneyCheckAlt}
                    size='2x'
                    style={{color: elRed}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Expenses
                </LinkWording>
              </Link>
            </LinkContainer>
            <LinkContainer>
              <Link
                to={"/accounting/invoices"}
                style={{textDecoration: 'none'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faFileInvoice}
                    size='2x'
                    style={{color: elRed}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Invoices
                </LinkWording>
              </Link>
            </LinkContainer>
            <LinkContainer>
              <Link
                to={"/accounting/payments"}
                style={{textDecoration: 'none'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faWallet}
                    size='2x'
                    style={{color: elRed}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Payments
                </LinkWording>
              </Link>
            </LinkContainer>
          </LinksContainer>
          <LinksContainer>
            <ContainerLabel>Transactions</ContainerLabel>
            <LinkContainer>
              <Link
                to={"/accounting/reports"}
                style={{textDecoration: 'none', marginTop: '10px'}}
              >
                <span className="fa-layers">
                  <FontAwesomeIcon
                    icon={faFileExport}
                    size='2x'
                    style={{color: elRed}}
                  />
                </span>
                <LinkWording style={{marginLeft: '30px'}}>
                  Reports
                </LinkWording>
              </Link>
            </LinkContainer>
          </LinksContainer>
        </LowerContainer>
      </ContentContainer>
    </MainContainer>
  )
}

export default AccountingDashboard;